import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import videojs from 'video.js';
import 'video.js/dist/video-js.css';

// eslint-disable-next-line import/prefer-default-export
const usePlayer = ({ src, thumb, controls, autoplay, isFluid }) => {
  console.log('wowow', thumb);

  const options = {
    fill: true,
    fluid: !!isFluid,
    preload: 'auto',
    html5: {
      hls: {
        enableLowInitialPlaylist: true,
        smoothQualityChange: true,
        overrideNative: true,
      },
    },
  };
  const videoRef = useRef(null);
  const [player, setPlayer] = useState(null);

  useEffect(() => {
    const vjsPlayer = videojs(videoRef.current, {
      ...options,
      controls,
      autoplay,
      sources: [src],
      poster: thumb,
    });
    setPlayer(vjsPlayer);

    return () => {
      if (player !== null) {
        player.dispose();
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (player !== null) {
      player.src({ src });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [src]);

  return videoRef;
};

const VideoPlayer = ({ src, thumb, controls, autoplay, isFluid = true }) => {
  const playerRef = usePlayer({ src, thumb, controls, autoplay, isFluid });

  return (
    <div data-vjs-player>
      <video ref={playerRef} className="video-js" />
    </div>
  );
};

VideoPlayer.propTypes = {
  src: PropTypes.string.isRequired,
  controls: PropTypes.bool,
  autoplay: PropTypes.bool,
};

VideoPlayer.defaultProps = {
  controls: true,
  autoplay: false,
};

export default VideoPlayer;
